import React from 'react';

const TextError = ({ children }) => {
    return (
        <div className="error color-red">
            {children}
        </div>
    );
};

export default TextError;